module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "md": 8
    }
  }, [_c('h1', {
    staticClass: "pageTitle"
  }, [_c('i', {
    staticClass: "fa fa-list-alt",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.batches.index.title')) + " (" + _vm._s(_vm.batches.pagination.totalCount) + ")")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "md": 16
    }
  }, [_c('div', {
    staticClass: "listOptions pull-right"
  }, [_c('el-button-group', [_c('el-button', {
    attrs: {
      "type": _vm.primary,
      "size": "small",
      "icon": "el-icon-menu",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeView('info')
      }
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": _vm.info,
      "size": "small",
      "icon": "el-icon-tickets",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeView('primary')
      }
    }
  })], 1), _vm._v(" "), _c('v-text', {
    staticClass: "searchForm",
    attrs: {
      "name": "search",
      "type": "text",
      "translation": "search.title",
      "value": _vm.search,
      "clearable": true
    },
    on: {
      "keydown": _vm.onChangeSearch
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('sort.title')) + " ")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": _vm.$t('sort.placeholder')
    },
    model: {
      value: (_vm.sort),
      callback: function($$v) {
        _vm.sort = $$v
      },
      expression: "sort"
    }
  })], 1)])], 1), _vm._v(" "), (_vm.info == 'info') ? _c('el-row', {
    attrs: {
      "gutter": 5
    }
  }, [(_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }],
    staticStyle: {
      "background": "transparent"
    }
  }, [_c('br'), _c('br')]) : _c('div', {
    staticClass: "flex stretch wrap"
  }, [(_vm.batches.items.length === 0) ? _c('v-no-data', [_vm._v("\n        " + _vm._s(_vm.$t('static.defaultText.batch.noDataMsg')) + "\n        "), (!_vm.bridgeStockWriteBlocked) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'production.batches.create'
      }
    }
  }, [_vm._v("\n           "), _c('el-button', [_vm._v("\n            " + _vm._s(_vm.$t('static.defaultText.batch.noDataBtn')) + "\n          ")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.batches.items), function(m, i) {
    return _c('v-card', {
      key: i,
      nativeOn: {
        "click": function($event) {
          return _vm.viewBatch(m)
        }
      }
    }, [_c('label', {
      staticClass: "cardLabel"
    }, [_c('span', {
      staticClass: "cardBadge"
    }, [_vm._v(_vm._s(_vm.$t(("static.batches.statuses." + (m.status)))))])]), _vm._v(" "), _c('h2', {
      staticClass: "cardTitle"
    }, [(m.status !== 'planned') ? _c('span', [_vm._v(_vm._s(m.batchNumber) + ":")]) : _vm._e(), _vm._v(_vm._s(m.name))]), _vm._v(" "), _c('hr'), _vm._v(" "), (m.plannedStartingDate && m.status === 'planned') ? _c('div', {
      staticClass: "cardinnerBox"
    }, [_vm._v("\n          " + _vm._s(_vm.$t('static.batches.view.plannedStartingDate')) + "\n          "), _c('div', [_c('label', {
      staticClass: "cardLabel cardLabel--small"
    }, [_c('i', {
      staticClass: "fa fa-calendar",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("  " + _vm._s(m.plannedStartingDate))])])]) : _vm._e(), _vm._v(" "), (m.startDate && (m.status !== 'planned' && m.status !== 'completed')) ? _c('div', {
      staticClass: "cardinnerBox"
    }, [_vm._v("\n          " + _vm._s(_vm.$t('static.batches.view.startDate')) + "\n          "), _c('div', [_c('label', {
      staticClass: "cardLabel cardLabel--small"
    }, [_c('i', {
      staticClass: "fa fa-calendar",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("  " + _vm._s(m.startDate))])])]) : _vm._e(), _vm._v(" "), (m.description) ? _c('div', {
      staticClass: "cardinnerBox"
    }, [_c('div', [_c('label', {
      staticClass: "cardLabel cardLabel--small"
    }, [_c('i', {
      staticClass: "fa fa-file-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("  " + _vm._s(m.description))])])]) : _vm._e()])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.primary == 'info') ? _c('el-row', {
    attrs: {
      "gutter": 5
    }
  }, [(_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }],
    staticStyle: {
      "background": "transparent"
    }
  }, [_c('br'), _c('br')]) : _c('v-table', {
    attrs: {
      "list": _vm.batchesListView,
      "noDataMessage": _vm.$t('static.defaultText.batch.noDataMsg'),
      "link": _vm.viewBatch,
      "linkKey": "name",
      "rowKey": "id",
      "translation": "static.batches.table"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
    staticClass: "pagination"
  }, [_c('v-pagination', {
    attrs: {
      "pagination": _vm.batches.pagination,
      "switchFunction": _vm.all
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23ae5b59","hasScoped":true}!./src/app/pages/withNavigation/batches/index/index.html
// module id = 2940
// module chunks = 1